import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useCommunity } from '@contexts/CommunityContext';
import api from '@helpers/api';

const PAGE_SIZE = 10;

export default function useForms() {
    const { slug } = useParams();
    const { community, loading: communityLoading } = useCommunity();

    const [forms, setForms] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');

    const currentCommunity = community.getBySlug(slug);

    useEffect(() => {
        if (!communityLoading && currentCommunity?.id) {
            handleLoad();
        }
    }, [communityLoading, currentCommunity?.id]);

    async function handleLoad() {
        setLoading(true);
        try {
            const { data } = await api.get(`communities/${currentCommunity.id}/forms`);
            const list = Array.isArray(data) ? data : data?.data ?? [];
            setForms(list);
            setPage(1);
        } catch (e) {
            console.error(e);
            setForms([]);
        }
        setLoading(false);
    }

    const filtered = search
        ? forms.filter(f => f.title?.toLowerCase().includes(search.toLowerCase()))
        : forms;

    const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
    const pagedForms = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

    function handleSelectPage(p) {
        setPage(p);
    }

    function handleSearch(value) {
        setSearch(value);
        setPage(1);
    }

    return {
        forms: pagedForms,
        allForms: filtered,
        loading,
        page,
        pages: totalPages,
        records: filtered.length,
        search,
        handleSearch,
        handleSelectPage,
        handleLoad,
        currentCommunity,
    };
}
